import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";

export const pagoMiembroValido = (form) => Number(form.miembro_paga) !== 1 || (
    Number.isFinite(Number(form.precio_miembro)) && Number(form.precio_miembro) >= 0.01
    && Number(form.precio_miembro) <= 99999999.99
);

export const pagoMiembroPayload = (form) => ({
    miembro_paga: Number(form.miembro_paga) === 1 ? 1 : 0,
    precio_miembro: Number(form.miembro_paga) === 1 ? Number(form.precio_miembro) : 0,
});

export const PagoMiembroFields = ({ form, onChange, invitadosPenya, onInvitadosPenyaChange }) => (
    <>
        <Grid size={{ xs: 12 }}>
            <FormControlLabel
                control={<Checkbox checked={Number(form.miembro_paga) === 1}
                    onChange={(event) => onChange("miembro_paga", event.target.checked ? 1 : 0)} />}
                label="El membre paga en aquest esdeveniment"
            />
        </Grid>
        {Number(form.miembro_paga) === 1 && (
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField fullWidth required variant="outlined" type="number" label="Preu per membre (€)"
                    value={form.precio_miembro ?? ""}
                    onChange={(event) => onChange("precio_miembro", event.target.value)}
                    slotProps={{ htmlInput: { min: 0.01, max: 99999999.99, step: "0.01" } }}
                    error={!pagoMiembroValido(form)}
                    helperText={!pagoMiembroValido(form)
                        ? "El preu per membre ha de ser superior a 0 €."
                        : "Import que paga cada membre a banda de la quota de la penya."}
                />
            </Grid>
        )}
        {onInvitadosPenyaChange && (
            <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                    fullWidth
                    type="number"
                    label="Convidat Ge."
                    value={invitadosPenya ?? 0}
                    onChange={(event) => onInvitadosPenyaChange(Math.max(0, parseInt(event.target.value, 10) || 0))}
                    slotProps={{ htmlInput: { min: 0, step: 1 } }}
                />
            </Grid>
        )}
    </>
);
